(ns frontend.view.settings2.data-import.view
  (:require
    [reagent.core :as r]
    [common.localization :as loc]
    [frontend.view.not-found :as not-found]
    [frontend.state.current-session :as session]
    [frontend.routing :as routing]
    [frontend.page-components.zap-toolbar :as zap-toolbar]
    [frontend.page-components.default-page-layout :as default-page-layout]
    [ui.components.button.view :as button]
    [ui.components.breadcrumbs.view :as breadcrumbs]))

(defonce state (r/atom {}))

(defn breadcrumbs
  []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [e]
                 (routing/set-view! [:account-settings :tab-key "data"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:active? true}
    (loc/tr :settings/data-import)]])

(defn component
  []
  (r/create-class
   {:reagent-render
    (fn []
      (let []
        [:<>
         [zap-toolbar/view state breadcrumbs nil nil #_(toolbar-actions feature-on?) nil]
         [:div
          {:class "px-4 py-6 mx-auto max-w-5xl"}

          [:div
           [:div
            {:class "flex flex-col gap-4"}
             [:span 
              {:class "text-xl font-bold"}
              (loc/tr :import-data-from-excel)]
            [:div
             {:class "flex flex-col gap-4"}
             [:div
              {:class "border border-solid border-base-light-border-paler roundeds"}
              [:div
               {:class "px-3 py-3 font-medium border-b border-solid border-base-light-border-paler roundeds"}
               (loc/tr :importing-step-1-heading)]
              [:div
               {:class "p-3 flex flex-col gap-3"}
               [:p 
                {:class "text-base-light-text-paler"}
                (loc/tr :importing-step-1-sub-heading)]
               
               [:ul
                {:class "grid grid-cols-2 gap-4"}
                [:li
                 [:div
                  [button/secondary-hollow
                   {:on-click   (fn [_]
                                  (routing/set-view! [:new-settings/data-import]
                                                     {:import-type :contacts}))
                    :class "w-full"}
                   [:span (loc/tr :import-new-contacts-button)]]]]
                [:li
                 [:div
                  [button/secondary-hollow
                   {:on-click   (fn [_]
                                  (routing/set-view! [:new-settings/data-import]
                                                     {:import-type :companies}))
                    :class "w-full"}
                   [:span (loc/tr :import-new-companies-button)]]]]
                (when (session/has-feature-access? :feature/asset-types-real-estate)
                  [:li
                   [:div
                    [button/secondary-hollow
                     {:on-click   (fn [_]
                                    (routing/set-view! [:new-settings/data-import]
                                                       {:import-type :real-estate}))
                      :class "w-full"}
                     [:span (loc/tr :import-real-estate)]]]])
                (when (session/has-feature-access? :feature/asset-types-other)
                  [:li
                   [:div
                    [button/secondary-hollow
                     {:on-click   (fn [_]
                                    (routing/set-view! [:new-settings/data-import]
                                                       {:import-type :other-asset}))
                      :class "w-full"}
                     [:span (loc/tr :import-other-asset)]]]])
                (when (session/has-feature-access? :feature/asset-types-fof)
                  [:li
                   [:div
                    [button/secondary-hollow
                     {:on-click   (fn [_]
                                    (routing/set-view! [:new-settings/data-import]
                                                       {:import-type :fof-assets}))
                      :class "w-full"}
                     [:span (loc/tr :import-new-fof-assets-button)]]]])]]]

             [:div
               {:class "border border-solid border-base-light-border-paler roundeds"}
              [:div
               {:class "px-3 py-3 font-medium border-b border-solid border-base-light-border-paler roundeds"}
               (loc/tr :importing-step-2-heading)]
              [:div 
               {:class "p-3 flex flex-col gap-3"}
               [:p 
                {:class "text-base-light-text-paler"}
                (loc/tr :importing-step-2-sub-heading)]
               [:ul
                {:class "grid grid-cols-2 gap-4"}
                [:li
                 [:div
                  [button/secondary-hollow
                   {:on-click   (fn [_]
                                  (routing/set-view! [:new-settings/data-import]
                                                     {:import-type :investors}))
                    :disabled?   (and (not (session/fundraising?))
                                      (not (session/portfolio?))
                                      (not (session/kyc?))
                                      (not (session/sales-pipelines?)))
                    :class "w-full"}
                   [:span (loc/tr :import-new-investors-button)]]]]]]]

             [:div
               {:class "border border-solid border-base-light-border-paler roundeds"}
              [:div 
               {:class "px-3 py-3 font-medium border-b border-solid border-base-light-border-paler roundeds"}
               (loc/tr :importing-step-3-heading)]
              [:div
               {:class "p-3 flex flex-col gap-3"}
               [:p 
                {:class "text-base-light-text-paler"}
                (loc/tr :importing-step-3-sub-heading)]
               [:ul
                {:class "grid grid-cols-2 gap-4"}
                [:li
                 [:div
                  [button/secondary-hollow
                   {:on-click   (fn [_]
                                  (routing/set-view! [:new-settings/data-import]
                                                     {:import-type :deals}))
                    :disabled?   (not (session/dealflow?))
                    :class "w-full"}
                   [:span (loc/tr :import-new-deals-button)]]]]

                [:li
                 [:div
                  [button/secondary-hollow
                   {:on-click   (fn [_]
                                  (routing/set-view! [:new-settings/data-import]
                                                     {:import-type :fundraising-opportunities}))
                    :disabled?   (not (session/fundraising?))
                    :class "w-full"}
                   [:span (loc/tr :import-new-fundraising-opportunities-button)]]]]]]]


             [:div
              {:class "border border-solid border-base-light-border-paler roundeds"}
              [:div
               {:class "px-3 py-3 font-medium border-b border-solid border-base-light-border-paler roundeds"}
               (loc/tr :importing-step-4-heading)]
              [:div
               {:class "p-3 flex flex-col gap-3"}
               [:p
                {:class "text-base-light-text-paler"}
                (loc/tr :importing-step-4-sub-heading)]
               [:ul
                {:class "grid grid-cols-2 gap-4"}
                [:li
                 [:div
                  [button/secondary-hollow
                   {:on-click   (fn [_]
                                  (routing/set-view! [:new-settings/data-import]
                                                     {:import-type :company-contacts}))
                    :class "w-full"}
                   [:span (loc/tr :import-company-contacts)]]]]


                (when (session/has-feature-access? :feature/asset-types-fof)
                  [:li
                   [:div
                    [button/secondary-hollow
                     {:on-click   (fn [_]
                                    (routing/set-view! [:new-settings/data-import]
                                                       {:import-type :fof-asset-contacts}))
                      :class "w-full"}
                     [:span (loc/tr :import-fof-asset-contacts)]]]])

                [:li
                 [:div
                  [button/secondary-hollow
                   {:on-click   (fn [_]
                                  (routing/set-view! [:new-settings/data-import]
                                                     {:import-type :deal-contacts}))
                    :disabled?   (not (session/dealflow?))
                    :class "w-full"}
                   [:span (loc/tr :import-deal-contacts)]]]]
                (when (session/has-investors-access?)
                  [:li
                   [:div
                    [button/secondary-hollow
                     {:on-click   (fn [_]
                                    (routing/set-view! [:new-settings/data-import]
                                                       {:import-type :investor-contacts}))
                      :class "w-full"}
                     [:span (loc/tr :import-investor-contacts)]]]])

                (when (session/fundraising?)
                  [:li
                   [:div
                    [button/secondary-hollow
                     {:on-click   (fn [_]
                                    (routing/set-view! [:new-settings/data-import]
                                                       {:import-type :froppo-contacts}))
                      :class "w-full"}
                     [:span (loc/tr :import-froppo-contacts)]]]])

                (when (session/holding-access?)
                  [:li
                   [:div
                    [button/secondary-hollow
                     {:on-click   (fn [_]
                                    (routing/set-view! [:new-settings/data-import]
                                                       {:import-type :holding-contacts}))
                      :disabled?   (= :plan/fundraising
                                     (->> @session/tenant
                                          :tenant/product-plan
                                          :plan/type))
                      :class "w-full"}
                     [:span (loc/tr :import-holding-contacts)]]]])]]]

             (when (or (session/has-funds-access?)
                       (and (session/fundraising?)
                            (= :plan/fundraising
                               (->> @session/tenant
                                    :tenant/product-plan
                                    :plan/type))))
               [:div
                {:class "border border-solid border-base-light-border-paler roundeds"}
                [:div
                 {:class "px-3 py-3 font-medium border-b border-solid border-base-light-border-paler roundeds"}
                 (loc/tr :importing-step-5-heading)]
                [:div
                 {:class "p-3 flex flex-col gap-3"}
                 [:ul
                  {:class "grid grid-cols-2 gap-4"}
                  [:li
                   [:div
                    [button/secondary-hollow
                     {:on-click   (fn [_]
                                    (routing/set-view! [:new-settings/data-import]
                                                       {:import-type :fund-commitments}))
                      :class "w-full"}
                     [:span (loc/tr :import-new-fund-commitments-button)]]]]
                  (when (session/has-funds-access?)
                    [:li
                     [:div
                      [button/secondary-hollow
                       {:on-click   (fn [_]
                                      (routing/set-view! [:new-settings/data-import]
                                                         {:import-type :funds}))
                        :class "w-full"}
                       [:span (loc/tr :import-new-funds-button)]]]])]]])]]]]]))}))

;;note: current version is in frontend.view.data-import.view
(defmethod routing/render-view :import-data
  [_]
  (if (session/is-admin?)
    [default-page-layout/view
     [component]]
    [not-found/not-found-view]))
